/**
 * Shared fetch helper for the /api/ai-services proxy, extracted from the
 * 4 near-identical copies previously hand-rolled in useRiskRegister.ts,
 * usePortfolioRisksList.ts, useTodaysQueue.ts, and useAccountActions.ts
 * (GitHub #540). Includes 204 No Content handling — 2 of the 4 originals
 * lacked it, which meant a DELETE endpoint returning 204 (e.g.
 * DELETE /api/v1/risk-register/accounts/{id}/risks/{riskId}) would throw
 * trying to parse an empty body as JSON.
 */

export const AI_SERVICES_API_BASE = '/api/ai-services';

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${AI_SERVICES_API_BASE}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...init?.headers },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw Object.assign(
      new Error(body?.error || body?.detail || `HTTP ${res.status}`),
      { status: res.status }
    );
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}
